var a = /* @__PURE__ */ ((r) => (r.Large = "large", r.Medium = "medium", r.Small = "small", r))(a || {});
export {
  a as SizesEnum
};
